import { useEffect, useState } from 'react'

/**
 * Возвращает изменный стейт через опеределенную задержку
 *
 * @param value значение.
 * @param delay задержка.
 * @returns значение, спустя задержку.
 */
const useDebounce = <T>(value: T, delay?: number): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || 500)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}

export default useDebounce
